<template>
  <div class="evento-container">

    <br><br>

    <!-- ========================= -->
    <!--    FRASE DE PRESENTACIÓN  -->
    <!-- ========================= -->
    <div class="frase-container">
      <p class="frase">     
        Hoy dejo atrás mis años de infancia,<br>
        para comenzar una nueva etapa en mi vida.<br>
        Mis padres, con amor y paciencia,<br>
        han sido mis guías en este camino.
      </p>

      <p class="frase">
        Desde mi corazón quiero invitarlos<br>
        a celebrar junto a nosotros<br>
        <span class="british">mis 21 años</span>,<br>
        un día muy especial que guardaré por siempre.
      </p>

      <!-- FIRMA -->
      <p class="firma">Jonathan <br>Chinos de la Paz</p>

      <!-- NUEVO BLOQUE AGREGADO -->
      <p class="agradecimiento"><br> 
        Agradezco a mis padres:<br> 
        <span class="resaltar">Ismael Chinos Casarreal</span> y<br>
        <span class="resaltar">Cristina Delapaz Flores</span>.
      </p>

      <p class="agradecimiento">
        Mis padrinos<br>
        <span class="resaltar">Oralia Deyta</span> y<br>
        <span class="resaltar">Pedro Rodiles</span>
      </p>

      <br><br><br><br>
    </div>

  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { gsap } from 'gsap'

export default {
  name: 'EventoSection',
  setup() {
    const infoRecepcion = ref(null)
    const lineaDecorativa = ref(null)
    const imgRecepcion = ref(null)

    const dressCodeRef = ref(null)
    const dressLineRef = ref(null)

    const animarElemento = (el) => {
      gsap.fromTo(el, { opacity: 0, y: 60 }, { opacity: 1, y: 0, duration: 1.2, ease: 'power2.out' })
    }

    const animarLinea = (el) => {
      gsap.fromTo(el, { scaleX: 0 }, { scaleX: 1, transformOrigin: 'left center', duration: 1.1 })
    }

    const animarDressCode = () => {
      gsap.fromTo(dressCodeRef.value, { opacity: 0, y: 40 }, { opacity: 1, y: 0, duration: 1 })
      animarLinea(dressLineRef.value)

      const glow = dressCodeRef.value.querySelector('.dresscode-glow')
      gsap.to(glow, { opacity: 0.7, duration: 2, yoyo: true, repeat: -1 })
    }

    onMounted(() => {
      const observar = (ref, accion, opts = { threshold: 0.4 }) => {
        if (!ref?.value) return
        const obs = new IntersectionObserver((entries, o) => {
          entries.forEach((e) => {
            if (e.isIntersecting) {
              accion()
              o.unobserve(e.target)
            }
          })
        }, opts)
        obs.observe(ref.value)
      }

      observar(imgRecepcion, () => animarElemento(imgRecepcion.value))
      observar(infoRecepcion, () => animarElemento(infoRecepcion.value))
      observar(lineaDecorativa, () => animarLinea(lineaDecorativa.value))
      observar(dressCodeRef, animarDressCode, { threshold: 0.25 })
    })

    return {
      infoRecepcion,
      lineaDecorativa,
      imgRecepcion,
      dressCodeRef,
      dressLineRef
    }
  }
}
</script>

<style scoped>
/* ===== CONTENEDOR GENERAL ===== */
.evento-container {
 background-image:
    linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0),
      rgba(0, 0, 0, 0.041),
      rgba(0,0,0,0.15)
    ),
    url('@/assets/madera.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  color: #fff;
  margin-top: -120px;
  padding-bottom: 40px;
  position: relative;
}

/* ========================= */
/*  FRASE DE PRESENTACIÓN    */
/* ========================= */
.frase-container {
  text-align: center;
  padding: 0 22px;
  margin-bottom: 50px;
  margin-top: -20px;
}

.frase {
  font-family: 'nombre';
  font-size: 17px;
  line-height: 1.6;
  color: #ffffff;
  margin-bottom: 18px;
}

.frase .british {
  font-family: 'british';
  font-size: 24px;
  color: #ffffff;
  letter-spacing: 1px;
}

.firma {
  font-family: 'hombre';
  font-size: 28px;
  margin-top: 10px;
  color: #ffffff;
}

/* NUEVO ESTILO PARA AGRADECIMIENTO */
.agradecimiento {
  font-family: 'nombre';
  font-size: 21px;
  line-height: 1.9;
  margin-top: 14px;
  color: #ffffff;
}

.agradecimiento .resaltar {
  font-family: 'hombre';
  font-size: 20px;
  line-height: 1.8;

  color: #ffffff;
  letter-spacing: 1px;
}

/* ===== MAPA ICONO ===== */
.icono-mapa {
  width: 70px;
  height: auto;
  filter: brightness(0) invert(1);
}
</style>
